import { Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const EmailCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return <Text>{rowData.email}</Text>;
};

const EmailColumn = () => ({
    accessorKey: 'email',
    header: 'Email',
    size: 1,
    Cell: ({ cell }) => <EmailCell cell={cell} />,
});
export default EmailColumn;
